module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iq4NK"))).then(() => parcelRequire('f4eak'));